<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>
    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/additional-categories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                {{ isNew ? 'Добавить' : 'Редактировать' }}
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <span class="table-string-delete" v-show="!isNew && !shippingPacking" @click="remove"><i
                        class="fa fa-trash-o"></i>Удалить строку</span>
                    </div>
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Наименование</label>
                        <fieldset :class="{'fieldset-error': errors.has('name')}">
                          <input type="text" v-model="name" :disabled="shippingPacking"
                                 v-validate="'required'" :class="{'input': true}" name="name">
                          <span v-show="errors.has('name')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Цена, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('price')}">
                          <input type="number" v-model="price"
                                 v-validate="'required'" :class="{'input': true}" name="price">
                          <span v-show="errors.has('price')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset" v-show="!shippingPacking">
                        <label class="fieldset-title">Исполнители</label>
                        <fieldset>
                          <ul class="workers-list">
                            <li>
                              <label class="checkbox-label"><input type="checkbox"
                                                                   v-model="loadersCheckbox">Грузчики</label>
                            </li>
                            <li>
                              <label class="checkbox-label"><input type="checkbox"
                                                                   v-model="driversCheckbox">Водители</label>
                            </li>
                            <li>
                              <label class="checkbox-label"><input type="checkbox" v-model="furnitureMakersCheckbox">Мебельщики</label>
                            </li>
                            <li>
                              <label class="checkbox-label">
                                <input type="checkbox" v-model="garbageTruckDriversCheckbox">Водители мусоровоза</label>
                            </li>
                          </ul>
                        </fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Зар. плата, руб.</label>
                        <fieldset :class="{'fieldset-error': errors.has('salary')}">
                          <input type="number" v-model="salary"
                                 v-validate="'required'" :class="{'input': true}" name="salary">
                          <span v-show="errors.has('salary')" class="error-text">Заполните обязательное поле</span>
                        </fieldset>
                      </div>
                      <div class="fieldset" v-show="!shippingPacking">
                        <label class="fieldset-title">Упаковка</label>
                        <fieldset><label class="checkbox-label"><input type="checkbox" v-model="packing">Является
                          упаковкой</label></fieldset>
                      </div>
                      <div class="cashless-block">
                        <div class="fieldset">
                          <div class="title">Надбавка за безнал</div>
                        </div>
                        <div class="fieldset">
                          <label class="fieldset-title">Надбавка за единицу услуги, руб.</label>
                          <fieldset :class="{'fieldset-error': errors.has('priceSurchargeByCashless')}">
                            <input type="number" v-model="priceSurchargeByCashless"
                                   v-validate="'required'" :class="{'input': true}" name="priceSurchargeByCashless">
                            <span v-show="errors.has('priceSurchargeByCashless')" class="error-text">Заполните обязательное поле</span>
                          </fieldset>
                        </div>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">
                          Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import VeeValidate from 'vee-validate'

    export default {
  name: 'AdditionalCategory',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    VeeValidate
  },

  data () {
    return {
      id: null,
      isNew: false,
      additionalCategory: {},
      newAdditionalCategory: {},
      workerTypes: []
    }
  },

  computed: {
    name: {
      get () {
        return !this.isNew ? this.additionalCategory.name : this.newAdditionalCategory.name
      },

      set (name) {
        !this.isNew ? this.additionalCategory.name = name : this.newAdditionalCategory.name = name
      }
    },
    price: {
      get () {
        return !this.isNew ? this.additionalCategory.price : this.newAdditionalCategory.price
      },

      set (price) {
        !this.isNew ? this.additionalCategory.price = price : this.newAdditionalCategory.price = price
      }
    },
    workerTypes: {
      get () {
        return !this.isNew ? this.additionalCategory.workerTypes : this.newAdditionalCategory.workerTypes
      },

      set (workerTypes) {
        !this.isNew ? this.additionalCategory.workerTypes = workerTypes : this.newAdditionalCategory.workerTypes = workerTypes
      }
    },
    salary: {
      get () {
        return !this.isNew ? this.additionalCategory.salary : this.newAdditionalCategory.salary
      },

      set (salary) {
        !this.isNew ? this.additionalCategory.salary = salary : this.newAdditionalCategory.salary = salary
      }
    },
    packing: {
      get () {
        return !this.isNew ? this.additionalCategory.packing : this.newAdditionalCategory.packing
      },

      set (packing) {
        !this.isNew ? this.additionalCategory.packing = packing : this.newAdditionalCategory.packing = packing
      }
    },
    shippingPacking: {
      get () {
        return !this.isNew ? this.additionalCategory.shippingPacking : this.newAdditionalCategory.shippingPacking
      },

      set (shippingPacking) {
        !this.isNew ? this.additionalCategory.shippingPacking = shippingPacking : this.newAdditionalCategory.shippingPacking = shippingPacking
      }
    },

    loadersCheckbox: {
      get () {
        return this.workerTypes.indexOf('Грузчики') > -1
      },

      set () {
        let workerTypeIndex = this.workerTypes.indexOf('Грузчики')
        if (workerTypeIndex > -1) {
          this.workerTypes.splice(workerTypeIndex, 1)
        } else {
          this.workerTypes.push('Грузчики')
        }
      }
    },

    driversCheckbox: {
      get () {
        return this.workerTypes.indexOf('Водители') > -1
      },

      set () {
        let workerTypeIndex = this.workerTypes.indexOf('Водители')
        if (workerTypeIndex > -1) {
          this.workerTypes.splice(workerTypeIndex, 1)
        } else {
          this.workerTypes.push('Водители')
        }
      }
    },

    furnitureMakersCheckbox: {
      get () {
        return this.workerTypes.indexOf('Мебельщики') > -1
      },

      set () {
        let workerTypeIndex = this.workerTypes.indexOf('Мебельщики')
        if (workerTypeIndex > -1) {
          this.workerTypes.splice(workerTypeIndex, 1)
        } else {
          this.workerTypes.push('Мебельщики')
        }
      }
    },

    garbageTruckDriversCheckbox: {
      get () {
        return this.workerTypes.indexOf('Водители мусоровоза') > -1
      },

      set () {
        let workerTypeIndex = this.workerTypes.indexOf('Водители мусоровоза')
        if (workerTypeIndex > -1) {
          this.workerTypes.splice(workerTypeIndex, 1)
        } else {
          this.workerTypes.push('Водители мусоровоза')
        }
      }
    },

    priceSurchargeByCashless: {
      get () {
        return !this.isNew ? this.additionalCategory.priceSurchargeByCashless : this.newAdditionalCategory.priceSurchargeByCashless
      },

      set (priceSurchargeByCashless) {
        !this.isNew ? this.additionalCategory.priceSurchargeByCashless = priceSurchargeByCashless
          : this.newAdditionalCategory.priceSurchargeByCashless = priceSurchargeByCashless
      }
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    this.id = this.$route.params.id
    if (this.id == 'new') {
      this.isNew = true
      this.newAdditionalCategory = {
        name: null,
        price: null,
        workerTypes: null,
        salary: null,
        packing: null,
        priceSurchargeByCashless: null
      }
    } else {
      api
        .getAdditionalCategoryById(this.id)
        .then(additionalCategory => {
          if (additionalCategory) {
            this.additionalCategory = additionalCategory
            this.isNew = false
            this.updateWorkerTypes(additionalCategory.workerTypes)
          }
        })
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    remove () {
      this.additionalCategory.removed = true
      this.save()
    },

    save () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$store.getters.waitingApiRequestsCount != 0) { return }

          this.isNew ? (
            this.newAdditionalCategory.workerTypes = this.workerTypes.join(', '),
            api
              .createAdditionalCategory(this.newAdditionalCategory)
              .then(() => {
                this.$router.push('/directories/additional-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
          ) : (
            this.additionalCategory.workerTypes = this.workerTypes.join(', '),
            api
              .updateAdditionalCategory(this.id, this.additionalCategory)
              .then(() => {
                this.$router.push('/directories/additional-categories')
                alert('Сохранено')
              })
              .catch(err => alert(err))
          )
        }
      })
    },

    updateWorkerTypes (workerTypesStr) {
      this.workerTypes = workerTypesStr.split(', ')
    }
  }
}
</script>
